module.exports = {"420625100":"城关镇","420625101":"石花镇","420625102":"盛康镇","420625103":"庙滩镇","420625104":"五山镇","420625105":"茨河镇","420625106":"南河镇","420625107":"紫金镇","420625108":"冷集镇","420625200":"赵湾乡","420625500":"薤山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420625.json
// module id = 1742
// module chunks = 0